import { render, staticRenderFns } from "./IcoCategory.vue?vue&type=template&id=4f69d3d0"
import script from "./IcoCategory.vue?vue&type=script&lang=js"
export * from "./IcoCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports